import { IconName } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import Tips from '../common/Tips'
import AddTeamAndMemberModule from './AddTeamAndMemberModule'

type TargetItem = {
  value: string
  label: string
  color: string
  icon: IconName
}

type TeamAndMembersConditionProps = {
  targetItem: TargetItem
  teams: { id: number, name: string }[]
  members: { id: number, name: string }[]
  teamCandidates: { id: number, name: string }[]
  memberCandidates: { id: number, name: string }[]
  participatingTeamIds: number[] | null
  participatingMemberIds: number[] | null
  onTeamsChange: (teams: { id: number, name: string }[]) => void
  onMembersChange: (members: { id: number, name: string }[]) => void
}

const TeamAndMembersCondition: FC<TeamAndMembersConditionProps> = (props) => {
  const {
    targetItem,
    teams,
    members,
    teamCandidates,
    memberCandidates,
    participatingTeamIds,
    participatingMemberIds,
    onTeamsChange,
    onMembersChange,
  } = props

  const isTeamExcluded = (id: number): boolean => participatingTeamIds !== null && !participatingTeamIds.includes(id)
  const isMemberExcluded = (id: number): boolean => participatingMemberIds !== null && !participatingMemberIds.includes(id)

  return (
    <>
      <div className="condition_header">
        <div className="condition_label">
          <FontAwesomeIcon
            icon={['fas', targetItem.icon as IconName]}
            style={{ color: targetItem.color }}
          />
          {targetItem.label}
        </div>
      </div>
      <div>
        <div className="detail_box">
          {
            teams.map((value) => {
              const excluded = isTeamExcluded(value.id)
              const chip = (
                <div
                  className="chip"
                  style={excluded ? { backgroundColor: "#ffd2d2" } : undefined}
                  key={`condition_team_${value.id}`}
                >
                  {`チーム「${value.name}」のメンバー`}
                  <span
                    className="chip_remove"
                    onClick={() => onTeamsChange(teams.filter((w) => w.id !== value.id))}
                    role="none"
                  >
                    <FontAwesomeIcon icon={['fas', 'times']} />
                  </span>
                </div>
              )
              return excluded ? (
                <Tips
                  key={`condition_team_tip_${value.id}`}
                  description="仕分け先プロジェクトの参加チームにいません。"
                  className=""
                  icon={false}
                >
                  {chip}
                </Tips>
              ) : chip
            })
          }
          {
            members.map((value) => {
              const excluded = isMemberExcluded(value.id)
              const chip = (
                <div
                  className="chip"
                  style={excluded ? { backgroundColor: "#ffd2d2" } : undefined}
                  key={`condition_member_${value.id}`}
                >
                  {value.name}
                  <span
                    className="chip_remove"
                    onClick={() => onMembersChange(members.filter((w) => w.id !== value.id))}
                    role="none"
                  >
                    <FontAwesomeIcon icon={['fas', 'times']} />
                  </span>
                </div>
              )
              return excluded ? (
                <Tips
                  key={`condition_member_tip_${value.id}`}
                  description="仕分け先プロジェクトの参加ユーザーにいません。"
                  className=""
                  icon={false}
                >
                  {chip}
                </Tips>
              ) : chip
            })
          }
          <div className="team_member_field">
            <AddTeamAndMemberModule
              teamIdList={teams.map((v) => v.id)}
              callbackTeams={(newTeams) => onTeamsChange(newTeams)}
              teamList={teamCandidates.map((v) => ({ ...v, origin_name: "", members: [] }))}
              memberIdList={members.map((v) => v.id)}
              callbackMembers={(newMembers) => onMembersChange(newMembers)}
              memberList={memberCandidates}
            />
          </div>
        </div>
      </div>
      <div>
        <div className="note_list">
          <div className="note">
            {`※ 指定チーム・ユーザー${(teams.length + members.length) > 1 ? "のいずれか" : ""}が含まれている場合、自動仕分けされます。`}
          </div>
        </div>
      </div>
    </>
  )
}

export default TeamAndMembersCondition
